import React from 'react';

import { WarehouseDocuments } from '../../components/WarehouseDocuments';

export const Acceptance: React.FC = () => <WarehouseDocuments kind="receipt" />;
